import React from 'react';
import SiteMapHeader from '../components/sitemap/SiteMapHeader';
import SiteMapIntro from '../components/sitemap/SiteMapIntro';
import SiteMapSection from '../components/sitemap/SiteMapSection';
import AdditionalPages from '../components/sitemap/AdditionalPages';
import { siteStructure, additionalPages } from '../components/sitemap/siteMapData';

// Fuente única (Res. MinTIC 1519/2020): canales de atención en el portal de ICETEX.
const CANALES_URL = 'https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania/canales-de-atencion/canales-digitales';

const SiteMap = () => {
  return (
    <section className="bg-fondo-claro" style={{ minHeight: 'calc(100vh - 120px)' }}>
      <SiteMapHeader />

      <div className="mx-auto max-w-[1200px] px-5 py-[60px]">
        <SiteMapIntro />

        <div
          className="grid mb-[70px]"
          style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '35px',
          }}
        >
          {siteStructure.map((section) => (
            <SiteMapSection key={section.id} section={section} />
          ))}
        </div>

        <AdditionalPages pages={additionalPages} />

        <div className="mb-[60px]">
          <div
            className="text-center rounded-[30px] p-[50px] border-2 border-icetex/20"
            style={{ background: 'linear-gradient(135deg, #e8f4ff 0%, #d4e9ff 100%)' }}
          >
            <div
              className="flex items-center justify-center mx-auto w-[70px] h-[70px] rounded-full mb-[25px] bg-gradient-to-br from-icetex to-icetex-dark"
              style={{ boxShadow: '0 8px 25px rgba(0, 63, 129, 0.3)' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-white"
                style={{ width: '35px', height: '35px' }}
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <h2 className="text-texto-oscuro font-bold text-[1.8rem] mb-5">
              ¿No encuentras lo que buscas?
            </h2>
            <p className="text-texto-sec mx-auto text-[1.1rem] leading-[1.8] max-w-[600px] mb-[30px]">
              Si necesitas ayuda para navegar nuestro sitio o tienes alguna pregunta,
              nuestro equipo está disponible para asistirte a través de múltiples canales de atención.
            </p>
            <a
              href={CANALES_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-white font-bold uppercase no-underline py-4 px-[40px] rounded-full text-[1rem] tracking-[0.5px] bg-gradient-to-br from-icetex to-icetex-dark hover:-translate-y-[3px] transition-all duration-300"
              style={{ boxShadow: '0 6px 20px rgba(0, 63, 129, 0.3)' }}
            >
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SiteMap;
